import { render, staticRenderFns } from "./InsuranceTariffsList.vue?vue&type=template&id=16e067ba&scoped=true"
import script from "./InsuranceTariffsList.vue?vue&type=script&lang=js"
export * from "./InsuranceTariffsList.vue?vue&type=script&lang=js"
import style0 from "./InsuranceTariffsList.vue?vue&type=style&index=0&id=16e067ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e067ba",
  null
  
)

export default component.exports